import { useQuery } from '@tanstack/react-query';
import { funnelAnalysisApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business メンズ正規登録導線ファネル（LP→会員登録→サブスク）の日次集計を取得するフック。
 * @graph-connects funnelAnalysisApi [calls] ファネル分析 API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useRegistrationFunnel(from?: string, to?: string) {
  return useQuery({
    queryKey: queryKeys.funnelAnalysis.registration(from, to),
    queryFn: () => funnelAnalysisApi.getRegistrationFunnel({ from, to }),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
